export function SkeletonCard() {
  return (
    <div className="pcard pcard-skeleton">
      <div className="skeleton" style={{ aspectRatio: '1 / 1', borderRadius: 'var(--radius-md)' }} />
      <div className="pcard-body">
        <div className="skeleton" style={{ height: 14, width: '70%', borderRadius: 6, marginBottom: 8 }} />
        <div className="skeleton" style={{ height: 18, width: '40%', borderRadius: 6 }} />
      </div>
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div className="skeleton-row">
      <div className="skeleton" style={{ width: 56, height: 56, borderRadius: 'var(--radius-sm)', flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <div className="skeleton" style={{ height: 12, width: '60%', borderRadius: 6, marginBottom: 6 }} />
        <div className="skeleton" style={{ height: 12, width: '35%', borderRadius: 6 }} />
      </div>
    </div>
  );
}

export function SkeletonAddressCard() {
  return (
    <div className="ab-card">
      <div className="ab-card-top">
        <div className="skeleton" style={{ width: 34, height: 34, borderRadius: 'var(--radius-sm)' }} />
        <div className="skeleton" style={{ height: 14, width: '40%', borderRadius: 6 }} />
      </div>
      <div className="ab-card-info">
        <div className="skeleton" style={{ height: 12, width: '90%', borderRadius: 6, marginBottom: 8 }} />
        <div className="skeleton" style={{ height: 12, width: '60%', borderRadius: 6, marginBottom: 8 }} />
        <div className="skeleton" style={{ height: 12, width: '50%', borderRadius: 6 }} />
      </div>
    </div>
  );
}

// Generic shimmer rectangle for chart/stat placeholders that don't fit the
// other fixed-shape skeletons below.
export function SkeletonBlock({ height = 24, width = '100%', borderRadius = 'var(--radius-sm)', style }) {
  return <div className="skeleton" style={{ height, width, borderRadius, ...style }} />;
}

// Drop-in <tbody> replacement for data tables -- keeps the real <thead> (and
// therefore any sorting/filtering UI in it) mounted and visible while rows load.
export function SkeletonTableRows({ rows = 5, cols = 4 }) {
  return (
    <tbody>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={r}>
          {Array.from({ length: cols }, (_, c) => (
            <td key={c}>
              <div className="skeleton" style={{ height: 13, width: c === 0 ? '80%' : '55%', borderRadius: 6 }} />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}

export function SkeletonDetail() {
  return (
    <div className="pdp-page">
      <div className="pdp-main">
        <div className="pdp-gallery">
          <div className="skeleton" style={{ width: '100%', aspectRatio: '1 / 1', borderRadius: 'var(--radius-lg)' }} />
        </div>
        <div className="pdp-info">
          <div className="skeleton" style={{ height: 14, width: '35%', borderRadius: 6, marginBottom: 14 }} />
          <div className="skeleton" style={{ height: 26, width: '85%', borderRadius: 8, marginBottom: 18 }} />
          <div className="skeleton" style={{ height: 20, width: '40%', borderRadius: 6, marginBottom: 22 }} />
          <div className="skeleton" style={{ height: 14, width: '100%', borderRadius: 6, marginBottom: 8 }} />
          <div className="skeleton" style={{ height: 14, width: '95%', borderRadius: 6, marginBottom: 8 }} />
          <div className="skeleton" style={{ height: 14, width: '70%', borderRadius: 6, marginBottom: 26 }} />
          <div className="skeleton" style={{ height: 34, width: '30%', borderRadius: 8 }} />
        </div>
        <aside className="pdp-sidebar">
          <div className="skeleton" style={{ height: 130, width: '100%', borderRadius: 'var(--radius-md)' }} />
          <div className="skeleton" style={{ height: 48, width: '100%', borderRadius: 'var(--radius-md)' }} />
          <div className="skeleton" style={{ height: 48, width: '100%', borderRadius: 'var(--radius-md)' }} />
        </aside>
      </div>
    </div>
  );
}
